import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(({ palette: { primary } }) => ({
  navbar: {
    background: primary.dark,
  },
}));
